module.exports = __webpack_public_path__ + "static/media/svb.fe91b0c1.png";